import { activeOrgSelector } from 'redux/reducer/AuthenticationReducer';
import { axiosInstance } from 'utils/http';
import { exportParameters } from 'utils/urlConstants';
import { showAlert } from 'redux/actions/AlertActions';
import { useDispatch, useSelector } from 'react-redux';
import { useMutation, useQueryClient } from 'react-query';


export const useDeleteExportParameter = () => {
  const queryClient = useQueryClient();
  const dispatch = useDispatch();
  const { ID: orgId } = useSelector(activeOrgSelector);

  return useMutation(
    ({ partnerAccountID, parameterID }) => {
      if (!orgId || !partnerAccountID || !parameterID) {
        throw new Error('Missing required identifiers');
      }
      return axiosInstance.delete(
        exportParameters(orgId).delete(partnerAccountID, parameterID),
      );
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries({ queryKey: ['ExportParameters', orgId] });
        dispatch(showAlert({
          message: 'Export parameter deleted successfully.',
          type: 'success',
        }));
      },
      onError: (err) => {
        dispatch(showAlert({
          message: err.response?.data?.message || 'Failed to delete export parameter.',
          type: 'error',
        }));
      },
    },
  );
};
